import { Pass } from "../../faceEffectPass";
// import VS from "!raw-loader!glslify-loader!./vertex.vert";
// import FS from "!raw-loader!glslify-loader!./fragment.frag";


//TEMPORARY PASSING THIS WAY AS  glslify-loader/raw-loader/Raw-body/@parcel/transformer-glsl not working --come back to this
const VS = /*glsl*/`
  precision mediump float;
  uniform mat3 uTextureMatrix;

  void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position,  0);
  }
`;

const FS = /*glsl*/`
  precision mediump float;

  uniform vec3 uResolution;
  uniform mat3 uTextureMatrix;
  uniform sampler2D uTexture;

  void main() {
    vec3 uv = vec3(gl_FragCoord) / uResolution;
    uv = vec3(uv.x, uv.y  , 1);
    uv = uTextureMatrix * uv;  
    vec3 c = texture2D(uTexture, uv.xy).rgb;
    gl_FragColor = vec4(c, 1.0);
  }

`;

export class CopyFacePass extends Pass {
  public constructor() {
    super(VS, FS);
  }
}